import { createFileRoute, redirect } from "@tanstack/react-router";

// /scripts retired — the browse-by-writing-script pages were thin and largely
// duplicated the category catalogue. Permanent redirect to /categories.
export const Route = createFileRoute("/scripts/")({
  beforeLoad: () => {
    throw redirect({ to: "/categories", statusCode: 301 });
  },
});
